import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { CreateGroupRequest } from './creategrouprequest';

export class CreateGroupAPI extends SixdeeCRBTAPI<CreateGroupRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/create-group
        return "create-group";
    }

    getRequestData()
    {
       return "aPartyMsisdn="+ this.getRequest().getCreateGroupRequest().getAPartyMsisdn()+"&"+
              "groupName="+ this.getRequest().getCreateGroupRequest().getGroupName()+"&"+
              "groupDesc="+ this.getRequest().getCreateGroupRequest().getGroupDesc()+"&"+
              "memberDetails="+ JSON.stringify(this.getRequest().getCreateGroupRequest().getMemberDetails())+"&"+
              "toneDetails=[\""+ this.getRequest().getCreateGroupRequest().getToneDetails() +"\"]&"+
              "priority="+ this.getRequest().getCreateGroupRequest().getPriority();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/creategroup/creategroupapi.tsx